import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class AttachmentBus extends BaseBus
{
    constructor(busObj: AttachmentBus = null) {
        super(busObj);
        if (busObj !== null) {
            this.addedDate = new Date(this.addedDate);
        }
    }
    CID(): any {
        return this.id;
    }
    setId(id: any) {
        this.id = id;
    }
    setParentId(id: any) {
        this.referenceId = id;
    }
    initialize(data: AttachmentBus) {
        super.initialize(data);
        try {
            this.addedDate = CommonFunctions.getDate(data.addedDate);
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
        }
        catch {

        }

    }
    setFromForm(data: AttachmentBus) {
        super.setFromForm(data);
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
            this.addedDate = date;
        }
        this.updateDt = date;
        this.updateUserId = userId;
        if (!CommonFunctions.hasGuidValue(this.personId)) {
            this.personId = personId;
        }
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
        this.personId = personId;
        this.addedDate = date;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
        this.addedDate = DateFunctions.getDateTimeWithUTCOffset(this.addedDate);
    }
    id: any;
    addedDate: Date;
    attachmentName: string;
    attachmentDesc: string;
    attachmentType: string;
    isImage: boolean;
    isDocument: boolean;
    isViewable: boolean;
    attachment: any;
    visibleToCustomer: Boolean;
    visibleToPurchasingOnly: Boolean;
    personName: string;
    personId: any;
    codeId: any;
    code: string;
    referenceId: any;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    dummy: any = null;
}
